import styles from "./Headline.module.scss";
import { FC } from "react";

interface IProp {
  title: string;
  disabled?: boolean;
}

const Headline: FC<IProp> = ({ title, disabled = false }: IProp) => {
  return (
    <div className={disabled ? styles.headlineDisabled : styles.headline}>
      <h3>{title}</h3>
    </div>
  );
};

export default Headline;
